/**
 * @author Matchexpo
 * @description 所有全局配置的状态管理，如无必要请勿修改
 */

const state = () => ({
  languageFormat: 'zh-cn'
})

const getters = {
  languageFormat: (state) => state.languageFormat
}
const mutations = {
  changeLanguageFormat(state, languageFormat) {
    state.languageFormat = languageFormat
  }
}
const actions = {
  setLanguageFormat: ({ commit }, changeLanguageFormat) => {
    commit('changeLanguageFormat', changeLanguageFormat)
  }
}
export default { namespaced: true, state, getters, mutations, actions }
